//1.引入
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)
//创建store
let store = new Vuex.Store({
	state:{
		//存放数据
		carPanelData:[],
		//pdfUrl:'http://192.168.3.159/Public/',
		pdfUrl:'https://chiguan-tech.cn/Public/',
		detailFlag:true
	},
	mutations:{
		
		addCarpanelData(state,data){
			var bOff=true;
			state.carPanelData.forEach((goods)=>{
				if(goods.sku_id == data.sku_id){
				   goods.count++;	
				   bOff=false;
				}
			});
			
			if (bOff) {
				let goodData = data;
				Vue.set(goodData,'count',1);
				state.carPanelData.push(goodData);
			}
			console.log(state.carPanelData);
		}
	}
})

//将store暴漏
export default store



// WEBPACK FOOTER //
// ./src/store/index.js